import utils from '../utils';

/**
 * Creates a `router-link` component to link within the app.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @param {Function} createElement
 * @returns {Array}
 */
export default function linkColumn({cachedColumn, rowData, createElement}) {
    if (!cachedColumn.props.to) {
        throw new Error(`Missing 'to' property for link column ${cachedColumn.header}`);
    }
    const links = utils.getCellValues({cachedColumn, rowData});
    let children;
    if (links.length) {
        const hasLabelInstruction = !!cachedColumn.props.label;
        const reducer = (reduced, value) => {
            // the `label` and `to` column properties will
            // receive the params below to allow them to access either the
            // row itself (fields) or the value within the cell (value)
            const params = {fields: rowData.fields, value};
            /* eslint-disable no-nested-ternary */
            const label = hasLabelInstruction
                ? cachedColumn.props.label.call(null, params)
                : (value === false
                    // if the value is `false` then is was empty,
                    // and we use the default empty HTML content
                    ? utils.emptyInnerHTML
                    : value);
            return reduced.concat(createElement(
                'router-link',
                {
                    attrs: {title: value},
                    props: {
                        to: cachedColumn.props.to.call(null, params),
                    },
                },
                label,
            ));
        };
        children = utils.separateChildren({
            values: links.reduce(reducer, []),
            createElement,
        });
    } else {
        // this is a fallback but should not occur, instead
        // use the value() column method to make sure a value
        // is indeed returned
        children = [utils.getEmptyCellElement(createElement)];
    }

    return [
        'div',
        children,
    ];
}
